<template>
  <div class="container-fluid mt-4 px-1">
    <div class="row gx-3"> 
      <div class="col-md-4">
        <ranking-list-card
          :horizontal-break="false"
          :card="{
            title: '이벤트 데이터',
          }"
          :item="dataList"
        >
        </ranking-list-card>
      </div>

      <div class="col-md-4">
        <div class="card shadow-sm p-4 h-100">
              <div class="col-md-6">
                <h6 class="pb-4 mb-0">입력 데이터</h6>
              </div>
          <form @submit.prevent="submitEvent">

            <div class="mb-3">
              <label for="parentID" class="form-label">제품 선택</label>
              <select v-model="form.parentID" class="form-select" id="parentID">
                <option value="">선택</option>
                <option v-for="item in form.productList" :key="item.id" :value="item.gtin">
                  {{ item.name + ' ( ' + item.gtin + ' )'}}
                </option>
              </select>
            </div>


            <div class="mb-3">
              <label for="epc" class="form-label">재료 목록</label>
              <multiselect id="multiselect" class="ms-urn" v-model="selectedUrns" :options="combinedList" :multiple="true" :close-on-select="false" :clear-on-select="false"
                        select-label="추가" selected-label="선택" deselect-label="삭제"
                        :preserve-search="true" placeholder="재료 선택" label="name" track-by="urn" :preselect-first="true">
              <template #selection="{ values }">
                <span class="multiselect__single"
                      v-if="values.length">{{ values.length }} 개 선택</span>
              </template>
              <template #option="{ option }">
                {{ option.name }} ({{ option.urn }})
              </template>
              </multiselect>
            </div>

            <!-- 스캔장소 (readPoint) -->
            <div class="mb-3">
              <label for="readPoint" class="form-label">스캔장소 (readPoint)</label>
              <select v-model="form.readPoint.manualURI" class="form-select" id="readPoint">
                <option value="">선택</option>
                <option v-for="item in readPointList" :key="item.id" :value="item.urn">
                  {{ item.name + ' ( ' + item.urn + ' )'}}
                </option>
              </select>
            </div>

            <!-- 입고장소 (bizLocation) -->
            <div class="mb-3">
              <label for="bizLocation" class="form-label">조립장소 (bizLocation)</label>
              <select v-model="form.bizLocation.manualURI" class="form-select" id="bizLocation">
                <option value="">선택</option>
                <option v-for="item in bizLocationList" :key="item.id" :value="item.urn">
                  {{ item.name + ' ( ' + item.urn + ' )'}}
                </option>
              </select>
            </div>

            <!-- 수량 -->
            <div class="mb-3">
              <label for="eventTime" class="form-label">이벤트 발생 시간</label>
              <input type="datetime-local" v-model="eventTimeTemp" class="form-control" id="eventTime" />
            </div>

            <!-- 등록 버튼 -->
            <div class="text-end">
              <button type="submit" class="btn btn-success">이벤트 등록</button>
            </div>
          </form>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card shadow-sm p-4">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0">선택 재료</h6>
          </div>
          <div class="selected-list">
            <template v-if="selectedUrns.length">
              <ul class="list-unstyled mb-0">
                <li v-for="it in selectedUrns" :key="it.urn" class="sel-item">
                  <div class="d-flex align-items-center justify-content-between">
                    <span class="prod-chip">{{ it.name }}</span>
                  </div>
                  <div class="urn-line" :title="it.urn">{{ it.urn }}</div>
                </li>
              </ul>
            </template>
            <div v-else class="empty-state">선택된 재료가 없습니다.</div>
          </div>
        </div>

        <div class="card shadow-sm p-4 mt-3">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0">탄소배출량</h6>
          </div>
          <div style="min-height: 120px;">
            
            <div class="co2e-kpis d-flex flex-wrap gap-3">
              <div class="co2e-kpi">
                <div class="co2e-label">선택 재료 수</div>
                <div class="co2e-value">{{ count }}</div>
              </div>
              <div class="co2e-kpi">
                <div class="co2e-label">단위당 평균</div>
                <div class="co2e-value">
                  {{ count > 0 ? fmtKg(avgKg) : '—' }} <span class="unit">kgCO₂e/개</span>
                </div>
              </div>
              <div class="co2e-kpi">
                <div class="co2e-label">선택재료 합계</div>
                <div class="co2e-value">
                  {{ count > 0 ? fmtKg(sumKg) : '—' }} <span class="unit">kgCO₂e</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <EventListTable
      :eventList="recentEventList"
      :loading="loadingEvents"
      :minBodyHeight="300"
      emptyMessage="최근 이벤트가 없습니다."
    />
  </div>
</template>
<script>
import { fetchRawMaterialData, fetchBizLocationData, fetchReadPointData, fetchProductData } from "../../api/common/initDataAPI";
import { pollEpcisEvent, saveBlockChain } from "@/api/common/blockchain.js";
import RankingListCard from "@/examples/Cards/RankingListCard.vue";
import EventListTable from "@/views/components/EventListTable.vue";
import Multiselect from 'vue-multiselect'
import api from '@/api/api';
import axios from 'axios';

export default {
  name: "EventPrc3",
  components: {
    RankingListCard,
    Multiselect,
    EventListTable,
  },
  inject: ['showLoading', 'hideLoading'],
  computed: {
    selectedNames() {
      return this.selectedUrns.map(opt => `${opt.name} (${opt.urn})`);
    },
    mfId() {
      return this.$store.getters['UserStore/getMfId'];
    },
    dataList() {
      return [{
        title: '이벤트타입',
        date: 'EventType',
        amount: 'TransformationEvent',
        icon: 'fa-info',
        color: 'dark',
      },
      {
        title: '업무단계',
        date: 'bizStep',
        amount: 'ASSEMBLING',
        icon: 'fa-info',
        color: 'dark',
      },
      {
        title: '처리상태',
        date: 'Disposition',
        amount: 'IN_PROGRESS',
        icon: 'fa-info',
        color: 'dark',
      }
      ]
    },
    count() {
      return this.selectedUrns.length;        // ✅ 실제 선택 개수
    },
    selectedEmissions() {
      return this.selectedUrns
        .map(o => Number(o.carbonEmission || 0))
        .filter(v => Number.isFinite(v));
    },
    avgKg() {
      if (!this.selectedEmissions.length) return 0;
      const sum = this.selectedEmissions.reduce((a, b) => a + b, 0);
      return sum / this.selectedEmissions.length;
    },
    sumKg() {
      if (!this.selectedEmissions.length) return 0;
      return this.selectedEmissions.reduce((a, b) => a + b, 0);
    },
  },
  watch: {
    'form.readPoint.manualURI'(urn) {
      const sel = this.readPointList.find(r => r.urn === urn);
      if (sel && sel.blId != null) {
        const blId = sel.blId;
        if(blId){
          const selBlId = this.bizLocationList.find(b => b.id === blId);
          if(selBlId) this.form.bizLocation.manualURI = selBlId.urn;
        }
      }
    },
    selectedUrns: {
      immediate: true,
      deep: true,
      handler() {
        const total = this.sumKg;                   // computed 총합
        this.form.extensions.carbonEmission = Number(total.toFixed(3));
      }
    }
  },
  data() {
    return {
      loadingEvents: true,
      epc: '',
      crtEventID: '', 
      eventTimeTemp: '',
      form: {
        productList: [],
        parentID: '',
        childEPCs: [],
        eventType: "TransformationEvent",
        action: 'ADD',
        businessStep: 'ASSEMBLING',
        disposition: 'IN_PROGRESS',
        eventTimeSelector: '',
        eventTime: {},
        quantity: '1',
        epcList: [],
        readpointselector: 'manually',
        readPoint: {
          gcpLength: null,
          manualURI: "",
        },
        businesslocationselector: "manually",
        bizLocation: {
          gcpLength: null,
          manualURI: "",
        },
        vocabularySyntax: 'URN',
        ordinaryEvent: true,
        RecordTimeOption: 'no',
        recordTimeType: 'SAME_AS_EVENT_TIME',
        PersistentDispositionType: null,
        PersistentDisposition: null,
        persistentDispositionCount: 0,
        persistentDispositionList: [],
        businessTransactionCount: 0,
        businessTransactionList: [],
        errorCorrectiveCount: 0,
        errorCorrectiveIdsList: [],
        eventID: false,
        eventIdType: 'UUID',
        hashAlgorithm: 'sha-256',
        extensions: {
          carbonEmission: 0,
        },
      },
      rawMaterialList: [],
      combinedList: [],
      bizLocationList: [],
      readPointList: [],

      selectedUrns: [],
      search: '',

      recentEventList: [],

    }
  },
  async mounted() {
    this.eventTimeTemp = this.setDefaultTime();

    let now = new Date()
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset())
    now.setSeconds(now.getSeconds(), 0)
    now = now.toISOString().slice(0, -1)

    this.form.eventTime = {
      specificTime: now,
      fromTime: now,
      toTime: now,
      timeZoneOffset: '+09:00'
    }

    this.$store.state.DesignTestDataStore.eventType = "TransformationEvent";

    const [rawList, bizList, readList, prdList] = await Promise.all([
      fetchRawMaterialData(this.mfId),
      fetchBizLocationData(this.mfId),
      fetchReadPointData(this.mfId),
      fetchProductData(this.mfId),
    ]);
    this.rawMaterialList = rawList;
    this.bizLocationList = bizList;
    this.readPointList   = readList;
    this.form.productList = prdList;

    await this.fetchRawMaterialEventData();
    this.fetchEventListData();
  },
  methods: {
    async fetchRawMaterialEventData() {
      try {
        const response = await axios.get(`/api/epcisAPI/events`, {
          params: {
            paths: `bizSteps/receiving/events?eventType=ObjectEvent&MATCH_epc=urn:epc:id:sgtin:${this.mfId}.5*`,
          }
        });

        const events = response.data.epcisBody.queryResults.resultsBody.eventList;
        this.eventEpcList = events.flatMap(event => event.epcList);

        this.combineLists();
      } catch (error) {
        console.error("정보 불러오기 실패:", error);
      }
    },
    combineLists() {
      this.combinedList = this.eventEpcList.map(serialUrn => {
        const baseUrn = serialUrn.split('.').slice(0, -1).join('.');
        const matchedMaterial = this.rawMaterialList.find(rm => rm.urn === baseUrn);
        return {
          name: matchedMaterial ? matchedMaterial.name : '알 수 없음',
          urn: serialUrn,
          // ✅ 단위 배출량(kgCO2e/개)을 함께 보관
          carbonEmission: Number(matchedMaterial?.carbonEmission ?? 0)
        };
      });
    },
    async submitEvent () {
      this.form.eventTime = this.syncEventTimeFromTemp(this.eventTimeTemp);
      this.showLoading?.('이벤트를 EPCIS에 저장중...');
      try {
        // 1) Vuex로 캡처 JSON 생성
        this.$store.dispatch('TestDataJsonPreparator/jsonPreparation', { formData: this.form })
        this.$store.commit(
          'TestDataGeneratorStore/populateTestDataInput',
          JSON.stringify(this.$store.state.TestDataJsonPreparator.testDataInputTemplate)
        )
        await this.$store.dispatch('TestDataGeneratorStore/testdataGenerator')
        const dataResult = JSON.stringify(this.$store.state.TestDataGeneratorStore.testDataOutput, null, 2)

        // 2) EPCIS 캡처 (eventID 세팅 및 저장)
        const cap = await this.captureApi(dataResult)
        if (!cap.success) throw new Error(cap.error || 'EPCIS 캡처 실패')

        this.showLoading?.('이벤트를 블록체인에 저장중...');
        // ✅ 공통 유틸 사용 (EPCIS → 블록체인)
        const committedEvent = await pollEpcisEvent(this.crtEventID, {
          timeout: 60000, startInterval: 800, maxInterval: 4000
        });
        await saveBlockChain(this.crtEventID, committedEvent, 60000);

        this.toastSuccess?.('저장 되었습니다.')
        setTimeout(() => this.fetchEventListData(), 2000)
      } catch (e) {
        console.error(e)
        this.toastError?.(e.message || '처리 중 오류가 발생했습니다.')
      } finally {
        this.hideLoading?.();
      }
    },

    // ✅ EPCIS 캡처: TransformationEvent 용 커스터마이즈 (eventID 생성/보관)
    async captureApi (dataResult) {
      try {
        const jsonData = JSON.parse(dataResult)
        const event = jsonData.epcisBody.eventList[0]

        // parentID → outputEPCList 채우기
        try {
          const parentUrn = this.gtinToGtinUri(this.form.parentID)
          const { data } = await api.post('/rawMaterial/maxSerial', { urn: parentUrn })
          const padded = String(data.result.maxSerial).padStart(4, '0')
          event.outputEPCList = [ `${parentUrn}.${padded}` ]
        } catch (err) {
          console.error('maxSerial 조회 실패:', err)
        }

        // 회사 prefix/배출량
        event['cbv:extension'] = event['cbv:extension'] || {}
        if (this.mfId) event['cbv:extension'].companyPrefix = this.mfId
        event['cbv:extension'].carbonEmission = Number(this.form.extensions.carbonEmission ?? 0)

        // 입력 원재료 EPC
        event.inputEPCList = this.selectedUrns.map(x => x.urn)
        delete event.epcList

        // ✅ eventID 없으면 생성해서 보관
        if (!event.eventID) {
          const id = (crypto?.randomUUID?.() || (Date.now().toString(36) + Math.random().toString(36).slice(2)))
          this.crtEventID = `urn:uuid:${id}`
          event.eventID = this.crtEventID
        } else {
          this.crtEventID = event.eventID
        }

        // 캡처 호출
        const resp = await fetch('/api/epcisAPI/capture', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(jsonData)
        })
        if (!resp.ok) throw new Error(`응답 오류: ${resp.status}`)

        const text = await resp.text()
        const result = text ? JSON.parse(text) : {}
        return { success: true, data: result }
      } catch (e) {
        console.error('전송 실패:', e)
        return { success: false, error: e.message || e }
      }
    },
    async fetchEventListData() {
      this.loadingEvents = true;
      try {

        const [res] = await Promise.all([
          api.get(`/event/list`, {
            params: { 
              mfId: this.mfId,
              eventType: this.form.eventType,
              bizStep: this.form.businessStep.toLowerCase(),
              disposition: this.form.disposition.toLowerCase()
            }
          }),
          new Promise(r => setTimeout(r, 600))
        ]);

        const result = res.data.result;
        this.recentEventList = result.recentEventList || [];
      } catch (error) {
        console.error("정보 불러오기 실패:", error);
      } finally {
        this.loadingEvents = false;
      }
    },
    fmtKg(n) {
      return Number(n).toFixed(3);
    },
  },
};
</script>



<style scoped>
@import "~vue-multiselect/dist/vue-multiselect.css";
::v-deep .ms-urn .multiselect__option { font-size: 13px; }


/* 리스트 컨테이너: 세로 스크롤 */
.selected-list { height: 280px; overflow-y: auto; }

/* 각 아이템 */
.sel-item {
  padding: .5rem .25rem;
  border-bottom: 1px solid rgba(0,0,0,.06);
}
.sel-item:last-child { border-bottom: none; }

/* 제품명 라벨 */
.prod-chip {
  display: inline-block;
  font-size: .8rem;
  font-weight: 700;
  padding: .25rem .6rem;
  border-radius: 9999px;
  background: #eef7ff;
  color: #0d6efd; /* 필요시 브랜드 컬러로 변경 */
}

/* URN 한 줄 + 가로 스크롤 */
.urn-line {
  margin-top: .35rem;
  font-size: 0.9rem;
  color: #6c757d;
  white-space: nowrap;
  overflow-x: auto;
}
.urn-line::-webkit-scrollbar { height: 6px; }
.urn-line::-webkit-scrollbar-thumb { background: rgba(0,0,0,.2); border-radius: 3px; }
.urn-line::-webkit-scrollbar-track { background: transparent; }

.empty-state {
  height: 100%;
  display: flex; align-items: center; justify-content: center;
  color: #9aa3ae; font-size: .95rem;
}

/* ===== 탄소배출량 KPI ===== */
.co2e-kpis {
  display: flex;
  flex-wrap: nowrap;        /* 줄바꿈 막기 */
  gap: 16px;                /* 카드 간격 */
  justify-content: space-between; /* 한 줄 배치 */
}

/* 각 KPI 카드 */
.co2e-kpi {
  flex: 1;                  /* 동일한 너비 분배 */
  min-width: 0;             /* 줄 안 넘치게 */
  padding: 14px 16px;
  border: 1px solid rgba(0,0,0,.06);
  border-radius: 12px;
  background: #fff;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0,0,0,.04);
  transition: transform .12s ease, box-shadow .12s ease, border-color .12s ease;
}

/* 라벨 */
.co2e-label {
  font-size: .78rem;
  font-weight: 700;
  color: #6b7280;
  margin-bottom: 4px;
}

/* 값 */
.co2e-value {
  font-size: 1.35rem;
  font-weight: 800;
  color: #111827;
  line-height: 1.2;
}

/* 단위를 아랫줄로 표시 */
.co2e-value .unit {
  display: block;       /* 한 줄 차지 */
  font-size: .8rem;
  font-weight: 700;
  color: #6b7280;
  margin-top: 2px;      /* 값과 간격 */
}

</style>